import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import { getProviderList, fetchProviderList, getProject, fetchProject, inviteProvider, 
  getTrainerIndex, fetchTrainerIndex } from '../../../store/client'

import DetailViewController from '../../../shared/ui/DetailViewController'
import { getTommorow } from '../../../shared/utilities/helpers'
import Button from '../../../shared/ui/Button'
import DialogBox from '../../../shared/ui/DialogBox'
import { NavigationContext } from '../../../shared/ui/NavigationController'
import TableData from '../../../shared/ui/TableData'
import Link from '../../../shared/ui/Link'

import InviteProviderForm from '../views/InviteProviderForm'

import { withStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'

import BackIcon from '@material-ui/icons/ArrowBackIos'


const styles = theme => ({
  root: {
  },
})

const InviteProviderController = ({ theme, classes, ...props }) => {
  const { isFetching, lastFetched, data, providers, trainerList, fetchTrainers, fetchProviderList, inviteProvider, fetchProject, orderKey } = props
  
  const navigationContext = useContext(NavigationContext)

  const [invite, setInvite] = useState(-1)

  useEffect(() => {
    fetchProject()
    fetchProviderList()
    fetchTrainers()
  }, [])  
  
//   const groups = [
//     { key: 'all', label: 'All' },
//     { key: 'draft', label: 'Draft' },
//     { key: 'private', label: 'Private' },
//     { key: 'public', label: 'Public' },
//   ]
  
  const columns = [
    { key: 'logo_url', label: 'Image', type: 'image', aspectRatio: 1.33, width: theme.spacing(15)},
    { key: 'name', label: 'Name' },
    { key: 'head_line', label: 'Headline'},
    { key: 'action', label: 'Action'}
  ]
  
  const getCellValue = (row, column, rowIndex, columnIndex) => {

    const hasProposalFrom = (item) => {
      return lastFetched && data.providers.find(p => p.uid == item.uid) != null
    }

    if (column.key == 'action') {
      return [
        <Button variant='contained' disabled={hasProposalFrom(row)}
            onClick={() => setInvite(rowIndex)}
        >{hasProposalFrom(row) ? 'Invited' : 'Invite'}</Button>
      ]
    } else if (column.key == 'name') {
      return (
        <Link to={'/provider/'+row.uid} target='_blank'>
          <Box>
            <Typography variant='body1'>
              {row[column.key]}
            </Typography>
            <Button variant='contained' color='default' >
              View
            </Button>
          </Box>
        </Link>
      )
    }
  
    return row[column.key]
  }

  const backButton = (
    <Button icon={BackIcon} onClick={() => navigationContext.openLink("/company/order/view/"+orderKey)}>
      Order Detail
    </Button>
  )
  
  return (
    <DetailViewController
      title={'Invite Provider'}
      isFetching={isFetching}
      lastFetched={lastFetched}
      backButton={backButton} 
      >
      <TableData
        columns={columns}
        lastFetched={providers.lastFetched}      
        isFetching={providers.isFetching}
        rows={providers.lastFetched ? providers.data : []}
        getCellValue={getCellValue}
        >
      </TableData>

      { invite >= 0 &&
        <DialogBox show={true} onClose={() => setInvite(-1)} title={'Invite Provider'} >
          <InviteProviderForm 
              initialData={providers.lastFetched && providers.data[invite]}
              trainers={trainerList.lastFetched ? trainerList.data.records.filter(item => parseInt(item.provider.uid) === parseInt(providers.data[invite].uid)) : []}
              onClose={() => setInvite(-1)}
              onSave={(value) =>{
                inviteProvider(value, () => {
                  navigationContext.showLoadingDialog(false)
                  navigationContext.showMessageDialog(true)
                  navigationContext.setMessageDialog({title:'Cool!', description:'Invitation has been sent, Please wait until ' + getTommorow() + ' 5PM at the latest to receive confirmation from the provider.'})
                  setInvite(-1)
                })
              }}
          />
        </DialogBox>
        }
    </DetailViewController>
  )
}

const mapStateToProps = (state, ownProps) => {
  let orderKey = ownProps.match.params.orderKey
  return {
    orderKey,
    ...getProject(state, orderKey),
    providers: getProviderList(state, orderKey),
    trainerList: getTrainerIndex(state, '', null),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let orderKey = ownProps.match.params.orderKey
  return {
    fetchProject: (refresh) => {
      dispatch(fetchProject(orderKey, true))
    },
    fetchProviderList: () => {
      dispatch(fetchProviderList(orderKey, true))
    },
    inviteProvider: (data, onComplete) => {
      dispatch(inviteProvider(orderKey, data, onComplete))
    },
    fetchTrainers: () => {
      dispatch(fetchTrainerIndex('', null, true))
    },
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(InviteProviderController)
)
